    export interface ICloneCustomerForFailedCreditCheckRequest {
        igsCustomerNumber: string;
        firstName: string;
        lastName: string;
        emailAddress: string;
        phoneNumber: string;
    }

    export class CloneCustomerForFailedCreditCheckRequest implements ICloneCustomerForFailedCreditCheckRequest {
        igsCustomerNumber: string;
        firstName: string;
        lastName: string;
        emailAddress: string;
        phoneNumber: string;
    }